import { Fragment, useState, useEffect, useRef } from 'react'
import { Link, useHistory, useParams, useLocation } from "react-router-dom";
import { Dialog, Disclosure, Menu, Transition, Listbox } from '@headlessui/react'
import { XIcon } from '@heroicons/react/outline'
import { MailIcon, PhoneIcon } from '@heroicons/react/solid'
import { ChevronDownIcon, FilterIcon, MinusSmIcon, PlusSmIcon, ViewGridIcon, CheckIcon, SelectorIcon } from '@heroicons/react/solid'

import LoadingBar from 'react-top-loading-bar'
import DealService from '../../services/DealService'
import { DealProvider, DealContext, useDeal } from '../../providers/DealProvider';

const filters = [];

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}


function DealFilter() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const [mobileFiltersOpen, setMobileFiltersOpen] = useState(false)
  const [categories, setCategories] = useState(false)

  const [state, dispatch] = useDeal()

  const { dealId, catSlug } = useParams();
  const location = useLocation();
  const history = useHistory();

  const ref = useRef(null);

  const loadCategories = () => {
    ref.current.continuousStart();

    DealService.getCategories().then((response) => {
      let payload = response.data.data;
      let error = response.data.errors;

      payload.categorySlug = catSlug;

      dispatch({
        type: 'category/load',
        payload: payload
      });
    });
  }

  const loadDeals = (category, searchQuery) => {
    ref.current.continuousStart();

    let filter = { name: 'All', key: null };
    if (category) {
      filter = {name: category, key: category};
    }

    dispatch({
      type: 'loading/all_deals/started',
    });

    // TCV2-3: Set perpage to a high number until we complete pagination
    DealService.getAllDeals(filter.key, 500, searchQuery).then((response) => {
      let payload = response.data.data;
      payload.category = filter;
  
      dispatch({
        type: 'set_deals',
        payload: payload
      });

      dispatch({
        type: 'loading/all_deals/finished',
      });

      if (ref.current)
        //changeFilter({name: 'All', key: null})
        ref.current.complete();
    });
  }

  const changeFilter = (filter) => {
    window.location = "/marketplace/category/" + filter.key;
    window.dataLayer.push({
      event: 'select_category',
      eventProps: {
        category_name: filter.key
      }
    });

    /*
    DealService.getAllDeals(filter.key).then((response) => {
      let payload = response.data.data;
      payload.category = filter;
  
      dispatch({
        type: 'set_deals',
        payload: payload
      });

      ref.current.complete();

    });
    */
  }

  useEffect(() => {
    loadCategories();
    const queryParams = location.search.split('=');
    const query = (queryParams.length > 1) ? queryParams[1] : null;

    loadDeals(catSlug, query);
  }, []);

  return (
    <aside>
      <LoadingBar color='#0173FF' ref={ref} />
      <h2 className="sr-only">Filters</h2>

      {/* Mobile Filter */}
        <div className="xl:hidden w-full xl:w-4/12 mx-auto">
          <Listbox value={state.category} onChange={ changeFilter }>
          {({ open }) => (
          <>
            <Listbox.Label className="relative dropdown-label z-10 block text-sm font-primary text-xs text-gray-700">Category</Listbox.Label>
            <div className="mt-1 relative">
                <Listbox.Button className="relative w-full bg-white border border-2 border-gray-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
                <span className="flex items-center">
                  <span className="ml-3 block truncate">{state.category.name}</span>
                </span>
                <span className="ml-3 absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                  <SelectorIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                </span>
              </Listbox.Button>
  
              <Transition
                show={open}
                as={Fragment}
                leave="transition ease-in duration-100"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <Listbox.Options className="absolute z-10 mt-1 w-full bg-white shadow-lg max-h-56 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm">
                  {state.categories.map((category) => (
                    <Listbox.Option
                      key={category.key}
                      className={({ active }) =>
                        classNames(
                          (active || category.key == catSlug)? 'text-white bg-indigo-600' : 'text-gray-900',
                          'cursor-default select-none relative py-2 pl-3 pr-9'
                        )
                      }
                      value={category}
                    >
                      {({ selected, active }) => (
                        <>
                          <div className="flex items-center">
                            <span
                              className={classNames(selected ? 'font-semibold' : 'font-normal', 'ml-3 block truncate')}
                            >
                              {category.name}
                            </span>
                          </div>
  
                          {selected ? (
                            <span
                              className={classNames(
                                active ? 'text-white' : 'text-indigo-600',
                                'absolute inset-y-0 right-0 flex items-center pr-4'
                              )}
                            >
                              <CheckIcon className="h-5 w-5" aria-hidden="true" />
                            </span>
                          ) : null}
                        </>
                      )}
                    </Listbox.Option>
                  ))}
                </Listbox.Options>
              </Transition>
            </div>
          </>
        )}
      </Listbox>
    </div>
    {/* End of Mobile Filter */}

      {/* Desktop Filter */}
      <form className="hidden xl:block w-[12.5rem]">
        <h3 className="font-header text-headline-4">Filter By Categories</h3>
        <div className="w-full border-t border-gray-300 my-4" />
        <h3 className="font-secondary text-overline uppercase text-grey-light">Offer Categories ({ state.categories.length })</h3>
        <ul role="list" className="text-sm font-subtitle text-body-1-md text-gray-900 space-y-2 pb-6 border-gray-200 mt-4">
            <a href="/marketplace" className="group cursor-pointer text-black border-b-2 border-transparent ">
              <li key="all" className="cursor-pointer w-60 px-4 py-2 rounded-md hover:text-blue-800 hover:bg-grey-filterHover">
                All
              </li>
            </a>
          {state.categories.map((category) => (
            <a key={category.key} id={category.key} href={`/marketplace/category/${category.key}`} className="group text-black border-b-2 border-transparent ">
              <li 
                key={category.key} 
                className={(category.key == catSlug) ?  "group cursor-pointer w-60 px-4 py-2 rounded-md text-blue-800 bg-grey-filterHover" : "group cursor-pointer w-60 px-4 py-2 rounded-md hover:text-blue-800 hover:bg-grey-filterHover"}
              >
                {category.name}
              </li>
            </a>
          ))}
    {/*
          <div className="w-full border-t border-gray-300 my-4" />
          <li 
            key="saved_deals"
            className="group cursor-pointer w-60 px-4 py-2 rounded-md hover:bg-grey-filterHover"
          >
            <a className="text-black border-b-2 border-transparent group-hover:text-blue-800">Saved Offers (0)</a>
          </li>
    */}
        </ul>
      </form>
    {/* End of Desktop Filter */}
    </aside>
  )
}

export default DealFilter;
